import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { VenusButton } from 'src/skins/venus/components/common';
import { TextInput } from 'src/skins/venus/components/inputs';
import AirtimeBeneficiaryItem from './beneficiaryItems/AirtimeBeneficiaryItem';
import { getBeneficiaries } from 'src/store/actions/beneficiaryActions';

const Wrapper = styled.div`
  .loading-state,
  .empty-state {
    display: flex;
    height: 15vh;
    min-height: 10rem;
    justify-content: center;
    align-items: center;
  }
`;

const MobileDataBeneficiaries = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const billType = history.location.state.type;

  const [search, setSearch] = useState('');

  const [currentBeneficiaries, setCurrentBeneficiaries] = useState({});
  const { beneficiaries, isLoading } = useSelector(state => state.BENEFICIARY);

  useEffect(() => {
    dispatch(getBeneficiaries(billType));
  }, [billType]);

  useEffect(() => {
    !isLoading.getBeneficiaries && setCurrentBeneficiaries(beneficiaries);
  }, [isLoading.getBeneficiaries]);

  const filterBeneficiaries = search => {
    if (search.length === 0) return setCurrentBeneficiaries(beneficiaries);

    const foundByName = beneficiaries.filter(x => x.name.toLowerCase().includes(search.trim().toLowerCase()));
    const foundByNetwork = beneficiaries.filter(x => x.network.toLowerCase().includes(search.trim().toLowerCase()));
    const foundByMobile = beneficiaries.filter(x =>
      String(x.mobile).toLowerCase().includes(search.trim().toLowerCase())
    );

    const result = Array.from(new Set([...foundByName, ...foundByNetwork, ...foundByMobile]));

    setCurrentBeneficiaries(result);
  };

  return (
    <Wrapper>
      <div>
        <TextInput
          type="text"
          label="Search saved beneficiary"
          placeholder="Enter beneficiary name"
          name="search"
          icon="search"
          required
          value={search}
          onChange={e => {
            setSearch(e.target.value);
            filterBeneficiaries(e.target.value);
          }}
        />
      </div>

      <br />

      {isLoading.getBeneficiaries && <div className="loading-state">fetching beneficiaries...</div>}
      {!isLoading.getBeneficiaries && currentBeneficiaries.length > 0 && (
        <>
          {currentBeneficiaries.map((item, index) => (
            <AirtimeBeneficiaryItem
              beneficiary={item}
              key={index}
              onClick={() =>
                history.push('/dashboard/bills/data', {
                  name: item.name,
                  mobile: item.mobile,
                  network: item.network,
                  state: true,
                })
              }
            />
          ))}
        </>
      )}
      {!isLoading.getBeneficiaries && currentBeneficiaries.length === 0 && (
        <div className="empty-state color-gray">No Beneficiaries Found</div>
      )}

      <br />

      <VenusButton size="large" text="New Mobile Data" onClick={() => history.push('/dashboard/bills/data')} />
    </Wrapper>
  );
};

export { MobileDataBeneficiaries };
